import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Button, SelectField, TextField } from "react-md";
import Autocomplete from "@material-ui/lab/Autocomplete";
import "../styles/createPlan.css";
import "../styles/assignServiceToPlan.css";
import FontIcon from "react-md/lib/FontIcons";
import "../styles/assignServiceToPlan.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import EventService from "../../../../../service/event/EventService";
import PlansUtils from "../services/PlansUtils";
import {
  Checkbox,
  IconButton,
  TextField as TextFieldMui,
} from "@material-ui/core";
import RangeSlider from "../services/RangeSlider";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import CloseIcon from "react-md-icon/dist/SharpClose";
import AssignedPlansUtil from "../services/AssignedPlansUtils";
import CreateServiceUtil from "../../service-module/services/CreateServiceUtil";
import ServiceDashboardUtils from "../../service-module/services/ServiceDashboardUtils";
import AssignServiceProviderUtil from "../../service-module/services/AssignServiceProviderUtil";
import ExpandableTableAssignedServiceProviders from "../helper/ExpandableTableAssignedServiceProviders";
import "../styles/advancedSponsorshipRule.css";

export const AdvancedSponsorshipRule = (props) => {
  const [planData, setPlanData] = useState({});
  const [popupDialogObject, setPopupDialogObject] = useState(null);
  const [infoPopupDialogObject, setInfoPopupDialogObject] = useState(null);

  const [formData, setFormData] = useState({
    isContinueClicked: false,
  });
  const [assignedServicesArray, setAssignedServicesArray] = useState([]);
  const [assignServiceToPlanModesData, setAssignServiceToPlanModesData] =
    useState({});
  const [
    extraAssignServiceToPlanModesData,
    setExtraAssignServiceToPlanModesData,
  ] = useState({});
  const [serviceTypeData, setServiceTypeData] = useState({});

  const [mode, setMode] = useState(1);
  const [accountDetails, setAccountDetails] = useState(null);
  const [familyRelationsArr, setFamilyRelationsArr] = useState([
    {
      code: 0,
      value: "Self",
      gender: 0,
    },
  ]);
  const [allRelations, setAllRelations] = useState([0]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [expandableTables, setExpandableTables] = useState(<></>);
  const [assignedServiceProviderPageNums, setAssignedServiceProviderPageNums] =
    useState({});
  const [pageSize, setPageSize] = useState(30);
  const [componentMounted, setComponentMounted] = useState(false);
  const [validModes, setValidModes] = useState([]);

  const plansUtils = new PlansUtils();
  const assignedPlansUtils = new AssignedPlansUtil();
  const createServiceUtil = new CreateServiceUtil();
  const assignServiceProviderUtil = new AssignServiceProviderUtil();
  const serviceDashboardUtils = new ServiceDashboardUtils();

  const EMPTY_BASE_GROUP = {
    services: [{ serviceId: null, groupedModes: null }],
  };
  const [baseGroups, setBaseGroups] = useState([EMPTY_BASE_GROUP]);
  const [groupRuleByIdResponse, setGroupRuleByIdResponse] = useState([
    EMPTY_BASE_GROUP,
  ]);

  const EMPTY_BASE_GROUP_SERVICE_OBJ = { serviceId: null, groupedModes: null };

  useEffect(() => {
    setComponentMounted(true);
    if (props?.data?.mode == "view" || props?.data?.mode == "update") {
      setFormData({
        isContinueClicked: true,
      });
      getGroupRuleById(props?.data?.serviceGroupRuleId);
    }
    getPlanByFilter(props?.data?.planId);
    getFamilyRelations();
    getServiceTypes("true");
  }, []);

  useEffect(() => {
    if (planData?.accountCode != null) {
      getAccountByAccountCode(planData?.accountCode);
    }
  }, [planData]);

  // useEffect(() => {
  //   if (
  //     (props?.data?.mode == "view" || props?.data?.mode == "update") &&
  //     (assignedServicesArray ?? []).length > 0
  //   ) {
  //     getServiceTypeDataById(assignedServicesArray?.[0]?.serviceTypeId);
  //     setFormData((prev) => ({
  //       ...prev,
  //       serviceTypeId: assignedServicesArray?.[0]?.serviceTypeId,
  //     }));
  //   }
  // }, [assignedServicesArray]);

  useEffect(() => {
    const serviceTypeIdInGroupRule = Object.values(
      groupRuleByIdResponse?.includedServiceTypes ?? {}
    )?.[0];
    if (
      props?.data?.mode == "view" &&
      (groupRuleByIdResponse?.includedServiceIds ?? []).length > 0 &&
      serviceTypeIdInGroupRule
    ) {
      getServiceTypeDataById(serviceTypeIdInGroupRule);
      setFormData((prev) => ({
        ...prev,
        serviceTypeId: serviceTypeIdInGroupRule,
      }));
      getAssignedServicesToPlanByFilter(
        props?.data?.planId,
        0,
        0,
        {
          Ids: groupRuleByIdResponse?.includedServiceIds ?? [],
        },
        true
      );
    } else if (
      props?.data?.mode == "update" &&
      (groupRuleByIdResponse?.includedServiceIds ?? []).length > 0 &&
      serviceTypeIdInGroupRule
    ) {
      getServiceTypeDataById(serviceTypeIdInGroupRule);
      setFormData((prev) => ({
        ...prev,
        serviceTypeId: serviceTypeIdInGroupRule,
      }));
      getAssignedServicesToPlanByFilter(
        props?.data?.planId,
        0,
        0,
        {
          Ids: groupRuleByIdResponse?.includedServiceIds ?? [],
        },
        true
      );
      getAssignedServicesToPlanByFilter(props?.data?.planId, 0, 0, {
        serviceTypeIds: [serviceTypeIdInGroupRule],
      });
    }
  }, [groupRuleByIdResponse]);

  const removeKey = (obj, keyToRemove) => {
    const newObj = { ...obj }; // Create a shallow copy to avoid mutating the original object
    delete newObj[keyToRemove]; // Delete the key
    return newObj;
  };

  const updateAssignServiceToPlanModesDataField = (
    parentKey,
    fieldKey,
    newValue
  ) => {
    // setAssignedServiceProviderData({serviceProvider: {id: "176df7y"}})

    setAssignServiceToPlanModesData((prevData) => ({
      ...prevData,
      [parentKey]: {
        ...prevData[parentKey],
        [fieldKey]: newValue,
      },
    }));
    if (fieldKey === "isEnabled" && newValue === false) {
      const newObj = removeKey(assignServiceToPlanModesData, parentKey);
      setAssignServiceToPlanModesData(newObj);
    }
  };

  const exitPage = () => {
    setPlanData({});
    setFormData({
      isContinueClicked: false,
    });
    setAssignServiceToPlanModesData({});
    setExtraAssignServiceToPlanModesData({});
    setServiceTypeData({});
    props.setView(3, {
      mode: "assign-service",
      accountId: props?.data?.accountId,
      planId: props?.data?.planId,
    });
    setValidModes([]);
  };

  const getServiceTypes = (status) => {
    const onResponse = (res) => {
      console.log("ni- service types res=", res);
      setServiceTypes(res);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching service types: ${err?.message}`,
      });
    };
    createServiceUtil.getServiceType(status, onResponse, onError);
  };

  const getAccountByAccountCode = (code) => {
    let body = {
      pageNum: 1,
      pageSize: 1,
      accountCode: code,
    };
    const onResponse = (res) => {
      setAccountDetails(res.accounts[0]);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.getAccountsByFilter(body, onResponse, onError);
  };

  const stringToInt = (str) => {
    const num = parseInt(str, 10); // Convert string to integer with base 10
    return isNaN(num) ? null : num; // Check if conversion failed
  };

  const getGroupRuleById = (id) => {
    let onResponse = (res) => {
      console.log("ni- got servType res for id=", res);
      setBaseGroups((prev) => res?.baseGroups ?? []);
      setGroupRuleByIdResponse((prev) => res);
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching the service provider details: ${err?.message}`,
      });
    };
    assignedPlansUtils.getGroupRuleById(id, onResponse, onError);
  };

  const getServiceTypeDataById = (id) => {
    let onResponse = (res) => {
      console.log("ni- got servType res for id=", res);
      setServiceTypeData(res);
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching the service provider details: ${err?.message}`,
      });
    };
    assignServiceProviderUtil.getServiceTypeById(id, onResponse, onError);
  };

  const getPlanByFilter = (planId) => {
    const onResponse = (res) => {
      console.log("ni- got res for getPlansByFilter: ", res);
      if (res?.plans?.[0]) {
        setPlanData((prevData) => res?.plans?.[0] ?? {});
      } else {
        EventService.emit("showError", {
          message: `No plan found with planId - (${planId.toString()})`,
        });
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching plan details: ${err?.message}`,
      });
    };
    assignedPlansUtils.getAssignedPlansByFilter(
      {
        pageNum: 1,
        pageSize: 1,
        planIds: [planId],
      },
      onResponse,
      onError
    );
  };

  const unpublishGroupRule = (id) => {
    const onResponse = (res) => {
      // if (props?.data?.mode == "assign") {
      //   console.log("ni- got res for assignServiceToPlan: ", res);
      //   EventService.emit("showError", {
      //     message: `Successfully assigned the service to the plan`,
      //   });
      // } else if (props?.data?.mode == "update") {
      //   console.log("ni- got res for updateAssignedServiceToPlan: ", res);
      //   EventService.emit("showError", {
      //     message: `Successfully updated the service assignment to plan`,
      //   });
      // }

      EventService.emit("showError", {
        message: `Advance rule unpublished successfully.`,
      });

      exitPage();
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in unpublishing advance rule: ${err?.message}`,
      });
    };

    assignedPlansUtils.unpublishGroupRule(id, {}, onResponse, onError);
  };

  const updateGroupRule = (body) => {
    const onResponse = (res) => {
      // if (props?.data?.mode == "assign") {
      //   console.log("ni- got res for assignServiceToPlan: ", res);
      //   EventService.emit("showError", {
      //     message: `Successfully assigned the service to the plan`,
      //   });
      // } else if (props?.data?.mode == "update") {
      //   console.log("ni- got res for updateAssignedServiceToPlan: ", res);
      //   EventService.emit("showError", {
      //     message: `Successfully updated the service assignment to plan`,
      //   });
      // }
      // exitPage();

      if (res?.status === 1) {
        EventService.emit("showError", {
          message: `Advance rule saved successfully`,
        });
        setGroupRuleByIdResponse((prev) => res);
        setPopupDialogObject({
          heading: "Saved successfully!",
          subHeading: (
            <p style={{ textAlign: "center", fontWeight: 400 }}>
              If you want to continue editing then click on{" "}
              <b>'Continue to edit'</b> otherwise click on <b>'Go back</b>
            </p>
          ),
          okayButtonText: "Continue to edit",

          okayButtonCallback: () => {
            setPopupDialogObject(null);
          },
          cancelButtonText: "Go back",
          cancelButtonCallback: () => {
            setPopupDialogObject(null);
            exitPage();
          },
        });
        return;
      } else if (res?.status === 2) {
        EventService.emit("showError", {
          message: `Advance rule published successfully`,
        });
        setGroupRuleByIdResponse((prev) => res);
        return;
      }

      EventService.emit("showError", {
        message: `Something went wrong while saving/publishing advance rule`,
      });
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in saving advance rule: ${err?.message}`,
      });
    };

    assignedPlansUtils.updateGroupRule(body?.id, body, onResponse, onError);
  };

  const createGroupRule = (body) => {
    const onResponse = (res) => {
      // if (props?.data?.mode == "assign") {
      //   console.log("ni- got res for assignServiceToPlan: ", res);
      //   EventService.emit("showError", {
      //     message: `Successfully assigned the service to the plan`,
      //   });
      // } else if (props?.data?.mode == "update") {
      //   console.log("ni- got res for updateAssignedServiceToPlan: ", res);
      //   EventService.emit("showError", {
      //     message: `Successfully updated the service assignment to plan`,
      //   });
      // }
      // exitPage();

      setGroupRuleByIdResponse((prev) => res);

      EventService.emit("showError", {
        message: `Advance rule saved successfully`,
      });

      setPopupDialogObject({
        heading: "Saved successfully!",
        subHeading: (
          <p style={{ textAlign: "center", fontWeight: 400 }}>
            If you want to continue editing then click on{" "}
            <b>'Continue to edit'</b> otherwise click on <b>'Go back</b>
          </p>
        ),
        okayButtonText: "Continue to edit",

        okayButtonCallback: () => {
          setPopupDialogObject(null);
        },
        cancelButtonText: "Go back",
        cancelButtonCallback: () => {
          setPopupDialogObject(null);
          exitPage();
        },
      });
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in saving advance rule: ${err?.message}`,
      });
    };

    assignedPlansUtils.createGroupRule(body, onResponse, onError);
  };

  const prepareBodyForGroupRuleCreation = () => {
    return {
      planId: planData?.id,
      status: 1,
      baseGroups,
    };
  };

  const prepareBodyForGroupRuleUpdation = (statuss, groupRuleId) => {
    return {
      planId: planData?.id,
      id: groupRuleId,
      status: statuss,
      baseGroups,
    };
  };

  const getFamilyRelations = () => {
    const onResponse = (res) => {
      let allRelations = res?.map((e) => {
        return e.code;
      });
      setAllRelations((prev) => [...prev, ...allRelations]);
      setFamilyRelationsArr((prev) => [...prev, ...res]);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching family relations: ${err?.message}`,
      });
    };
    plansUtils.getFamilyRelations(onResponse, onError);
  };

  const isServiceValidForConfirm = () => {
    let errorOccurred = false;
    if (formData?.service) {
      const serviceRequiredFields = [
        // "serviceTypeId",
        "id",
        // "name",
        // "serviceSubtypeName",
        // "serviceName",
      ];
      serviceRequiredFields.forEach((e) => {
        if (errorOccurred) return;
        if (formData?.service?.[e]) {
        } else {
          errorOccurred = true;
          EventService.emit("showError", {
            message: `${e} is required in service details`,
          });
        }
      });
    } else {
      EventService.emit("showError", {
        message: "Please enter service details",
      });
      errorOccurred = false;
      return false;
    }

    if (errorOccurred) {
      return false;
    }

    return true;
  };

  const reverseConvertServiceModesData = (array) => {
    if (!Array.isArray(array) || array.length === 0) {
      return {}; // Return an empty object if input is null, undefined, or empty
    }

    const ans = array.reduce((acc, item) => {
      const { modeName, ...rest } = item; // Extract mode as key, rest as value
      acc[modeName] = rest;
      return acc;
    }, {});

    return ans;
  };

  let areBaseGroupsValid = (baseGroups) => {
    let errorOccurred = false;

    for (let index = 0; index < (baseGroups ?? []).length; index++) {
      const group = (baseGroups ?? [])[index];

      for (let j = 0; j < (group?.services ?? []).length; j++) {
        const service = (group?.services ?? [])[j];

        if (!service?.serviceId) {
          errorOccurred = true;
          EventService.emit("showError", {
            message: `No service selected in group no. - (${
              index + 1
            }) at row no. - (${j + 1}). Empty row is not allowed in any group.`,
          });
          break;
        }
        if ((service?.groupedModes ?? []).length <= 0) {
          errorOccurred = true;
          EventService.emit("showError", {
            message: `At least one mode must be selected in group no. - (${
              index + 1
            }) at row no. - (${j + 1}).`,
          });
          break;
        }
      }

      if (errorOccurred) {
        break;
      }
    }

    if (errorOccurred) {
      return false;
    }

    return true;
  };

  let isFormValid = (formData, baseGroups) => {
    if (!props?.data?.planId) {
      EventService.emit("showError", {
        message: `Invalid plan ID`,
      });
      return false;
    }

    if (!formData?.serviceTypeId) {
      EventService.emit("showError", {
        message: `Please select a service type`,
      });
      return false;
    }

    if ((baseGroups ?? []).length <= 0) {
      EventService.emit("showError", {
        message: `Empty rules. Please prepare rules to add/update`,
      });
      return false;
    }

    let errorOccurred = false;

    for (let index = 0; index < (baseGroups ?? []).length; index++) {
      const group = (baseGroups ?? [])[index];

      for (let j = 0; j < (group?.services ?? []).length; j++) {
        const service = (group?.services ?? [])[j];

        if (!service?.serviceId) {
          errorOccurred = true;
          EventService.emit("showError", {
            message: `No service selected in group no. - (${
              index + 1
            }) at row no. - (${j + 1}). Empty row is not allowed in any group.`,
          });
          break;
        }
        if ((service?.groupedModes ?? []).length <= 0) {
          errorOccurred = true;
          EventService.emit("showError", {
            message: `At least one mode must be selected in group no. - (${
              index + 1
            }) at row no. - (${j + 1}).`,
          });
          break;
        }
      }

      if (errorOccurred) {
        break;
      }
    }

    if (errorOccurred) {
      return false;
    }

    return true;
  };

  const getAdvanceRuleSection = (
    rule,
    setAdvanceRule,
    idx,
    removeRule,
    alreadySelectedRelations,
    planServiceModeRules
  ) => {
    // prepare alreadySelectedRelations (by removing relations selected for current rule idx)
    let alreadySelectedRelationsExceptCurrent = [];
    alreadySelectedRelations.forEach((e, i) => {
      if (i != idx) {
        alreadySelectedRelationsExceptCurrent = [
          ...alreadySelectedRelationsExceptCurrent,
          ...e,
        ];
      }
    });

    return (
      <div className="mp-astp-rules-outer-div">
        <div className="mp-astp-rules-family-member-div">
          <div>
            Applicable for &nbsp; &nbsp;
            <Checkbox
              style={{ margin: 0, padding: 0 }}
              checked={
                (rule?.relations ?? []).length >=
                familyRelationsArr.length -
                  alreadySelectedRelationsExceptCurrent.length
              }
              color="secondary"
              disabled
              onChange={(e) => {
                console.log("clicked");
                if (e.target.checked) {
                  let allRelCodes = (familyRelationsArr ?? []).map(
                    (obj) => obj.code
                  );
                  let removedCommonRelCode = [];
                  allRelCodes.forEach((e) => {
                    if (!alreadySelectedRelationsExceptCurrent.includes(e)) {
                      removedCommonRelCode.push(e);
                    }
                  });
                  rule.relations = removedCommonRelCode;
                } else {
                  rule.relations = [];
                }
                setAdvanceRule(rule);
              }}
            />
            &nbsp; All
          </div>
          {Boolean(
            planServiceModeRules.length > 1 && props?.data?.mode != "view"
          ) && (
            <div
              className="mp-advance-rule-close-fonticon-astp"
              // onClick={(e) => removeRule(idx)}
            >
              <FontIcon>close</FontIcon>
            </div>
          )}
        </div>

        <div className="mp-adv-sp-rule-family-relations-bubbles-div">
          {familyRelationsArr &&
            familyRelationsArr?.map((rel) => {
              if (alreadySelectedRelationsExceptCurrent.includes(rel?.code)) {
                return <></>;
              }
              return (
                <div
                  className={
                    (rule?.relations ?? []).includes(rel?.code)
                      ? "mp-plan-box-selected"
                      : "mp-plan-box-unselected"
                  }
                  // onClick={() => {
                  //   if (props?.data?.mode == "view") {
                  //     return;
                  //   }
                  //   if ((rule?.relations ?? []).includes(rel?.code)) {
                  //     rule.relations = (rule?.relations ?? []).filter(
                  //       (item) => item !== rel?.code
                  //     );
                  //     setAdvanceRule(rule);
                  //   } else {
                  //     rule.relations = [...(rule?.relations ?? []), rel?.code];
                  //     setAdvanceRule(rule);
                  //   }
                  // }}
                >
                  <div className="mp-plan-font">
                    {rel.code == 6
                      ? "Daughter < 18"
                      : rel.code == 7
                      ? "Daughter > 18"
                      : rel.code == 8
                      ? "Son < 18"
                      : rel.code == 9
                      ? "Son > 18"
                      : rel.code == 6
                      ? "Daughter < 18"
                      : rel.value}
                  </div>
                </div>
              );
            })}
        </div>
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">
                <Checkbox
                  style={{ margin: 0, padding: 0 }}
                  checked={rule?.planAgeRule?.isApplicable ?? false}
                  color="secondary"
                  disabled
                  onChange={(e) => {
                    rule.planAgeRule.isApplicable = e.target.checked;
                    setAdvanceRule(rule);
                  }}
                />
                {`Age Rule Applicable (From ${rule?.planAgeRule?.fromAge} to ${rule?.planAgeRule?.toAge})`}
              </div>
              {/* <div> */}
              <RangeSlider
                min={rule.planAgeRule.fromAge}
                max={rule.planAgeRule.toAge}
                rangeMin={0}
                rangeMax={150}
                disabled
                setAge={(min, max) => {
                  rule.planAgeRule.fromAge = min;
                  rule.planAgeRule.toAge = max;
                  setAdvanceRule(rule);
                }}
              />
              {/* </div> */}
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container-v2">
              <div className="mp-plan-label">
                <Checkbox
                  style={{ margin: 0, padding: 0 }}
                  checked={rule?.planGenderRule?.isApplicable ?? false}
                  color="secondary"
                  disabled
                  onChange={(e) => {
                    rule.planGenderRule.isApplicable = e.target.checked;
                    setAdvanceRule(rule);
                  }}
                />
                {`Gender rule applicable`}
              </div>
              {/* <div> */}
              <SelectField
                menuItems={[
                  {
                    label: "Female",
                    value: 1,
                  },
                  {
                    label: "Male",
                    value: 2,
                  },
                ]}
                placeholder="Select"
                fullWidth
                disabled
                onChange={(e) => {
                  rule.planGenderRule.gender = e;
                  setAdvanceRule(rule);
                }}
                value={
                  rule?.planGenderRule?.gender
                    ? rule?.planGenderRule?.gender ?? ""
                    : ""
                }
              />
              {/* </div> */}
            </div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container-v2">
              <div className="mp-plan-label-v2">{`Custom sponsorship`}</div>
              <TextField
                fullWidth
                placeholder="0"
                value={
                  rule?.customSponsorshipDetails?.enabled
                    ? `${rule?.customSponsorshipDetails?.value ?? 0}${
                        rule?.customSponsorshipDetails?.unit === 1
                          ? " %"
                          : " (Rs)"
                      }`
                    : ""
                }
                disabled
                type="text"
                lineDirection="left"
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container-v2">
              <div className="mp-plan-label-v2">
                <Checkbox
                  style={{ margin: 0, padding: 0 }}
                  checked={!(rule?.planTimeRule?.isServiceAvailLimited ?? true)}
                  color="secondary"
                  disabled
                  onChange={(e) => {
                    if (e.target.checked) {
                      rule.planTimeRule.isTimeRuleApplicable = false;
                    }
                    rule.planTimeRule.isServiceAvailLimited = !e.target.checked;
                    setAdvanceRule(rule);
                  }}
                />
                {`Check mark if unlimited or define limit below`}
                <label className="account-module-label-red"> *</label>
              </div>
              {/* <div> */}
              <TextField
                fullWidth
                placeholder="Type here to define limit"
                value={
                  rule?.planTimeRule?.maxServiceAvailCount == 0
                    ? ""
                    : rule?.planTimeRule?.maxServiceAvailCount ?? ""
                }
                disabled
                onChange={(e) => {
                  rule.planTimeRule.maxServiceAvailCount = stringToInt(
                    e == "" ? "0" : e
                  );
                  setAdvanceRule(rule);
                }}
                type="number"
                lineDirection="left"
              />
              {/* </div> */}
            </div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container-v2">
              <div className="mp-plan-label">
                <Checkbox
                  style={{ margin: 0, padding: 0 }}
                  checked={
                    rule?.planTimeRule?.isInclusiveOfAllRelations ?? false
                  }
                  color="secondary"
                  disabled
                  onChange={(e) => {
                    rule.planTimeRule.isInclusiveOfAllRelations =
                      e.target.checked;
                    setAdvanceRule(rule);
                  }}
                />
                {`Inclusive of all`}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const getServicesAddedSection = () => {
    return (
      <div className="adv-sp-rule-services-added-section">
        <h4>Services added:</h4>
        {(formData?.servicesAdded ?? []).map((e) => (
          <div
            className={
              Boolean(
                (e?.id ?? -1) === (formData?.serviceSelectedForFocus?.id ?? -2)
              )
                ? "mp-plan-adv-sp-rule-box-selected"
                : "mp-plan-adv-sp-rule-box-unselected"
            }
            onClick={() => {
              setFormData((prev) => ({
                ...prev,
                serviceSelectedForFocus: e,
              }));
              if (e?.id) {
                setExtraAssignServiceToPlanModesData((prev) => ({
                  ...prev,
                  [e.id]: {
                    ...prev?.[e.id],
                    headerExpanded: true,
                  },
                }));
              }

              // taking out modes data for this service
              const assignServiceToPlanModesData =
                reverseConvertServiceModesData(e?.serviceModeDetails);

              // expanding all Expandable tiles of this service..
              (serviceTypeData?.modes ?? []).forEach((row, index) => {
                if (
                  e?.id &&
                  row &&
                  assignServiceToPlanModesData?.[row] &&
                  assignServiceToPlanModesData?.[row]?.isEnabled
                ) {
                  setExtraAssignServiceToPlanModesData((prev) => ({
                    ...prev,
                    [e.id]: {
                      ...prev?.[e.id],
                      [row.toString()]: {
                        ...prev?.[e.id]?.[row.toString()],
                        modeHeaderExpanded: true,
                        expanded:
                          assignServiceToPlanModesData?.[row]
                            ?.isAdvanceRuleApplicable ?? false,
                      },
                    },
                  }));
                }
              });
            }}
          >
            <div className="mp-plan-adv-sp-rule-font">{`(${e?.id ?? ""}) ${
              e?.name ?? ""
            } - ${e?.serviceName ?? ""}`}</div>

            <IconButton
              disabled={
                props?.data?.mode == "view" ||
                groupRuleByIdResponse?.status === 2
              }
              onClick={(event) => {
                setPopupDialogObject({
                  heading: "",
                  subHeading: (
                    <p style={{ textAlign: "center", fontWeight: 400 }}>
                      Are you sure you want to <b>remove the service</b>, once
                      removed, it will also be removed from advanced sponsorship
                      rule if already defined?
                    </p>
                  ),
                  okayButtonText: "Yes",

                  okayButtonCallback: () => {
                    setFormData((prev) => ({
                      ...prev,
                      servicesAdded: (prev?.servicesAdded ?? []).filter(
                        (elem) => (elem?.id ?? -1) !== (e?.id ?? -2)
                      ),
                      serviceSelectedForFocus:
                        (prev?.serviceSelectedForFocus?.id ?? -1) ===
                        (e?.id ?? -2)
                          ? null
                          : prev?.serviceSelectedForFocus,
                    }));
                    clearServiceIdAndGroupedModesWithServiceId(e?.id);
                    setPopupDialogObject(null);
                  },
                  okayButtonClassName: "mp-plan-button-save-enabled",
                  cancelButtonText: "No",
                  cancelButtonCallback: () => {
                    setPopupDialogObject(null);
                  },
                });
                event.stopPropagation();
              }}
              className="navigo-appoint-section-6-grid-edit-call"
            >
              <CloseIcon
                style={{
                  color: `${
                    Boolean(
                      (e?.id ?? -1) ===
                        (formData?.serviceSelectedForFocus?.id ?? -2) ||
                        props?.data?.mode == "view" ||
                        groupRuleByIdResponse?.status === 2
                    )
                      ? "#FFFFFF"
                      : "#000000"
                  }`,
                  height: "16px",
                  width: "16px",
                  fontWeight: 700,
                }}
              />
            </IconButton>
          </div>
        ))}
      </div>
    );
  };

  const clearServiceIdAndGroupedModesWithServiceId = (Id) => {
    //clear serviceId And its grouped modes in baseGroups if this service exist in baseGroup anywhere..

    for (let index = 0; index < (baseGroups ?? []).length; index++) {
      const group = (baseGroups ?? [])[index];
      for (let j = 0; j < (group?.services ?? []).length; j++) {
        const element = (group?.services ?? [])[j];
        if ((element?.serviceId ?? -2) === (Id ?? -1)) {
          baseGroups[index].services[j].serviceId = null;
          baseGroups[index].services[j].groupedModes = null;
        }
      }
    }
  };

  const getServiceModesSection = (service, assignServiceToPlanModesData) => {
    return (
      <div
        key={service.id}
        className="adv-sp-rule-service-modes-section-outermost-div"
      >
        <div
          style={
            Boolean(
              extraAssignServiceToPlanModesData?.[service?.id ?? "randomXYZ"]
                ?.headerExpanded ?? false
            )
              ? { borderBottom: "1px solid #c2c2c2" }
              : {}
          }
          className="adv-sp-rule-service-modes-section-service-header-div"
          onClick={(eve) => {
            if (service?.id) {
              setExtraAssignServiceToPlanModesData((prev) => ({
                ...prev,
                [service.id]: {
                  ...prev?.[service.id],
                  headerExpanded: !(
                    prev?.[service.id]?.headerExpanded ?? false
                  ),
                },
              }));
            }
          }}
        >
          <div style={{ fontWeight: 700 }}>{`(${service?.id ?? ""}) ${
            service?.name ?? ""
          } - ${service?.serviceName ?? ""}`}</div>

          <div className="adv-sp-rule-service-modes-section-service-header-icons-div">
            <div style={{ width: "20px" }}></div>
            {extraAssignServiceToPlanModesData?.[service?.id ?? "randomXYZ"]
              ?.headerExpanded ?? false ? (
              <FontIcon>arrow_drop_up</FontIcon>
            ) : (
              <FontIcon>arrow_drop_down</FontIcon>
            )}
            <div style={{ width: "20px" }}></div>

            <IconButton
              disabled={
                props?.data?.mode == "view" ||
                groupRuleByIdResponse?.status === 2
              }
              onClick={(event) => {
                setPopupDialogObject({
                  heading: "",
                  subHeading: (
                    <p style={{ textAlign: "center", fontWeight: 400 }}>
                      Are you sure you want to <b>remove the service</b>, once
                      removed, it will also be removed from advanced sponsorship
                      rule if already defined?
                    </p>
                  ),
                  okayButtonText: "Yes",

                  okayButtonCallback: () => {
                    setFormData((prev) => ({
                      ...prev,
                      servicesAdded: (prev?.servicesAdded ?? []).filter(
                        (elem) => (elem?.id ?? -1) !== (service?.id ?? -2)
                      ),
                      serviceSelectedForFocus:
                        (prev?.serviceSelectedForFocus?.id ?? -1) ===
                        (service?.id ?? -2)
                          ? null
                          : prev?.serviceSelectedForFocus,
                    }));
                    //clear serviceId And its grouped modes in baseGroups if this service exist in baseGroup anywhere..
                    clearServiceIdAndGroupedModesWithServiceId(service?.id);
                    setPopupDialogObject(null);
                  },
                  okayButtonClassName: "mp-plan-button-save-enabled",
                  cancelButtonText: "No",
                  cancelButtonCallback: () => {
                    setPopupDialogObject(null);
                  },
                });
                event.stopPropagation();
              }}
              className="navigo-appoint-section-6-grid-edit-call"
            >
              <CloseIcon
                style={{
                  color:
                    props?.data?.mode == "view" ||
                    groupRuleByIdResponse?.status === 2
                      ? "#ffffff"
                      : "#000000",
                  height: "20px",
                  width: "20px",
                  fontWeight: 700,
                }}
              />
            </IconButton>
          </div>
        </div>

        {Boolean(
          extraAssignServiceToPlanModesData?.[service?.id ?? "randomXYZ"]
            ?.headerExpanded ?? false
        ) &&
          (serviceTypeData?.modes ?? []).map((row, index) =>
            assignServiceToPlanModesData?.[row] &&
            assignServiceToPlanModesData?.[row]?.isEnabled ? (
              <div className="adv-sp-rule-service-modes-section-mode-outermost-div">
                <div
                  style={
                    Boolean(
                      extraAssignServiceToPlanModesData?.[
                        service?.id ?? "randomXYZ"
                      ]?.[row]?.modeHeaderExpanded ?? false
                    )
                      ? { borderBottom: "1px solid #c2c2c2" }
                      : {}
                  }
                  className="adv-sp-rule-service-modes-section-service-header-div"
                  onClick={(eve) => {
                    if (service?.id && row) {
                      setExtraAssignServiceToPlanModesData((prev) => ({
                        ...prev,
                        [service.id]: {
                          ...prev?.[service.id],
                          [row.toString()]: {
                            ...prev?.[service.id]?.[row.toString()],
                            modeHeaderExpanded: !(
                              extraAssignServiceToPlanModesData?.[
                                service?.id ?? "randomXYZ"
                              ]?.[row]?.modeHeaderExpanded ?? false
                            ),
                          },
                        },
                      }));
                    }
                  }}
                >
                  <div style={{ fontWeight: 700 }}>{row ? row : "None"}</div>

                  <div className="adv-sp-rule-service-modes-section-service-header-icons-div">
                    <div style={{ width: "20px" }}></div>
                    {extraAssignServiceToPlanModesData?.[
                      service?.id ?? "randomXYZ"
                    ]?.[row]?.modeHeaderExpanded ?? false ? (
                      <FontIcon>arrow_drop_up</FontIcon>
                    ) : (
                      <FontIcon>arrow_drop_down</FontIcon>
                    )}
                  </div>
                </div>

                {assignServiceToPlanModesData?.[row]?.isEnabled &&
                  (extraAssignServiceToPlanModesData?.[
                    service?.id ?? "randomXYZ"
                  ]?.[row]?.modeHeaderExpanded ??
                    false) && (
                    <div>
                      <Row className="mp-row--modes-textfields-astp">
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">
                              {`Service MRP (Rs)`}
                              <label className="account-module-label-red">
                                {" "}
                                *
                              </label>
                            </div>
                            <div>
                              <TextField
                                fullWidth
                                value={
                                  assignServiceToPlanModesData?.[row]
                                    ?.maxPrice ?? ""
                                }
                                onChange={(e) =>
                                  updateAssignServiceToPlanModesDataField(
                                    row.toString(),
                                    "maxPrice",
                                    stringToInt(e)
                                  )
                                }
                                disabled
                                type="number"
                                lineDirection="left"
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row className="mp-row--modes-textfields-astp">
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">
                              {`Discounted price (Rs)`}
                              <label className="account-module-label-red">
                                {" "}
                                *
                              </label>
                            </div>
                            <div>
                              <TextField
                                fullWidth
                                value={
                                  assignServiceToPlanModesData?.[row]
                                    ?.discountedPrice ?? ""
                                }
                                onChange={(e) =>
                                  updateAssignServiceToPlanModesDataField(
                                    row.toString(),
                                    "discountedPrice",
                                    stringToInt(e)
                                  )
                                }
                                disabled
                                type="number"
                                lineDirection="left"
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row className="mp-row--modes-textfields-astp">
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">
                              {`Service status on plan`}
                              <label className="account-module-label-red">
                                {" "}
                                *
                              </label>
                            </div>
                            <div>
                              <SelectField
                                menuItems={["Active", "Inactive"]}
                                fullWidth
                                onChange={(e) =>
                                  updateAssignServiceToPlanModesDataField(
                                    row.toString(),
                                    "isModeActive",
                                    e === "Active" ? true : false
                                  )
                                }
                                disabled
                                value={
                                  assignServiceToPlanModesData?.[row]
                                    ?.isModeActive === true
                                    ? "Active"
                                    : assignServiceToPlanModesData?.[row]
                                        ?.isModeActive === false
                                    ? "Inactive"
                                    : ""
                                }
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-assign-service-isRecommendedForYou-div">
                            <Checkbox
                              style={{ margin: 0, padding: 0 }}
                              checked={
                                assignServiceToPlanModesData?.[row]
                                  ?.isRecommendedForYou ?? false
                              }
                              color="secondary"
                              disabled
                              onChange={(e) => {
                                updateAssignServiceToPlanModesDataField(
                                  row.toString(),
                                  "isRecommendedForYou",
                                  e.target.checked
                                );
                              }}
                            />
                            <div style={{ width: "10px" }}></div>
                            <div className="mp-assign-service-apply-new-rule-label-div">
                              <div style={{ fontWeight: 500 }}>
                                {"Recommended for user"}
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <div
                        style={
                          Boolean(
                            extraAssignServiceToPlanModesData?.[
                              service?.id ?? "randomXYZ"
                            ]?.[row]?.expanded ?? false
                          )
                            ? { borderBottom: "1px solid #c2c2c2" }
                            : {}
                        }
                        className="adv-sp-rule-apply-new-rule-label-outer-div"
                        onClick={(e) => {
                          if (
                            assignServiceToPlanModesData?.[row]
                              ?.isAdvanceRuleApplicable ??
                            false
                          ) {
                            if (service?.id && row) {
                              setExtraAssignServiceToPlanModesData((prev) => ({
                                ...prev,
                                [service.id]: {
                                  ...prev?.[service.id],
                                  [row.toString()]: {
                                    ...prev?.[service.id]?.[row.toString()],
                                    expanded: !(
                                      extraAssignServiceToPlanModesData?.[
                                        service?.id ?? "randomXYZ"
                                      ]?.[row]?.expanded ?? false
                                    ),
                                  },
                                },
                              }));
                            }
                          } else {
                            if (service?.id && row) {
                              setExtraAssignServiceToPlanModesData((prev) => ({
                                ...prev,
                                [service.id]: {
                                  ...prev?.[service.id],
                                  [row.toString()]: {
                                    ...prev?.[service.id]?.[row.toString()],
                                    expanded: false,
                                  },
                                },
                              }));
                            }
                          }
                        }}
                      >
                        <Checkbox
                          style={{ margin: 0, padding: 0 }}
                          checked={
                            assignServiceToPlanModesData?.[row]
                              ?.isAdvanceRuleApplicable ?? false
                          }
                          color="secondary"
                          disabled
                        />
                        <div style={{ width: "10px" }}></div>
                        <div className="mp-assign-service-apply-new-rule-label-div">
                          <div style={{ fontWeight: 700 }}>
                            {"Apply sponsorship rules"}
                          </div>
                          <div className="mp-add-rule-btn-and-arrow-font-icon">
                            {extraAssignServiceToPlanModesData?.[
                              service?.id ?? "randomXYZ"
                            ]?.[row]?.expanded ?? false ? (
                              <FontIcon>arrow_drop_up</FontIcon>
                            ) : (
                              <FontIcon>arrow_drop_down</FontIcon>
                            )}
                            <div style={{ width: "20px" }}></div>
                          </div>
                        </div>
                      </div>
                      {Boolean(
                        extraAssignServiceToPlanModesData?.[
                          service?.id ?? "randomXYZ"
                        ]?.[row]?.expanded ?? false
                      ) &&
                        Boolean(
                          assignServiceToPlanModesData?.[row]
                            ?.planServiceModeRules
                        ) && (
                          <div className="mp-row-modes-adv-rules-div-astp">
                            {assignServiceToPlanModesData?.[
                              row
                            ]?.planServiceModeRules?.map((e, idx) =>
                              getAdvanceRuleSection(
                                e,
                                (newRuleObj) => {
                                  if (
                                    assignServiceToPlanModesData?.[row]
                                      ?.planServiceModeRules?.[idx]
                                  ) {
                                    assignServiceToPlanModesData[
                                      row
                                    ].planServiceModeRules[idx] = newRuleObj;
                                    updateAssignServiceToPlanModesDataField(
                                      row.toString(),
                                      "planServiceModeRules",
                                      assignServiceToPlanModesData[row]
                                        .planServiceModeRules
                                    );
                                  }
                                },
                                idx,
                                (indexToRemove) => {
                                  if (
                                    assignServiceToPlanModesData?.[row]
                                      ?.planServiceModeRules?.[indexToRemove]
                                  ) {
                                    const newArr = assignServiceToPlanModesData[
                                      row
                                    ].planServiceModeRules.filter(
                                      (_, index) => index !== indexToRemove
                                    );
                                    updateAssignServiceToPlanModesDataField(
                                      row.toString(),
                                      "planServiceModeRules",
                                      newArr
                                    );
                                  }
                                },
                                assignServiceToPlanModesData?.[
                                  row
                                ]?.planServiceModeRules?.map(
                                  (objectt) => objectt.relations
                                ),
                                assignServiceToPlanModesData?.[row]
                                  ?.planServiceModeRules ?? []
                              )
                            )}

                            <div className="mp-plan-label">
                              <Checkbox
                                style={{ margin: 0, padding: 0 }}
                                checked={
                                  assignServiceToPlanModesData?.[row]
                                    ?.isSponsoredOnly ?? false
                                }
                                color="secondary"
                                disabled
                                onChange={(e) => {
                                  updateAssignServiceToPlanModesDataField(
                                    row.toString(),
                                    "isSponsoredOnly",
                                    e.target.checked
                                  );
                                }}
                              />
                              {`Show this service only to users who are eligible to avail sponsored service`}
                            </div>
                          </div>
                        )}
                    </div>
                  )}
              </div>
            ) : (
              <></>
            )
          )}
      </div>
    );
  };

  function areSetAndArrayEqual(mySet, myArray) {
    if (mySet.size !== myArray.length) {
      return false; // Sizes must match for equality (after removing duplicates from array)
    }

    // Convert the array to a Set to handle duplicates and then compare
    const arrayAsSet = new Set(myArray);

    if (mySet.size !== arrayAsSet.size) {
      return false; // If the array had duplicates, its set representation will be smaller
    }

    for (const item of mySet) {
      if (!arrayAsSet.has(item)) {
        return false; // Element in set not found in array's unique elements
      }
    }
    return true;
  }

  const transformServicesArrayForGroupRule = (
    servicesAdded,
    currGroupIdx,
    currServiceObjIdx
  ) => {
    let isThisServiceAlreadyUsedInAnotherGroup = false;
    let isThisServiceAlreadyUsedInCurrGroupWithAllModesExhausted = false;
    let modesUsed = new Set();

    let servicesFiltered = (servicesAdded ?? []).filter((ele) => {
      // Case 1
      // once a service is used in a group/combination, then it can't be used in other.
      isThisServiceAlreadyUsedInAnotherGroup = false;

      for (let index = 0; index < (baseGroups ?? []).length; index++) {
        const group = (baseGroups ?? [])?.[index];

        if (currGroupIdx !== index) {
          isThisServiceAlreadyUsedInAnotherGroup = (group?.services ?? []).some(
            (service) => (service?.serviceId ?? -1) === (ele?.id ?? -2)
          );
        }

        if (isThisServiceAlreadyUsedInAnotherGroup) {
          break;
        }
      }

      if (isThisServiceAlreadyUsedInAnotherGroup) {
        return false;
      }

      // Case 2
      // once a service is used in a group, then it can be used again in the same group given its all modes are not exhausted/used yet (modes here refers to the modes which are enabled & IsAdvanceRuleApplicable as true).
      isThisServiceAlreadyUsedInCurrGroupWithAllModesExhausted = false;
      modesUsed = new Set();

      const currGroup = (baseGroups ?? [])?.[currGroupIdx];

      for (let index = 0; index < (currGroup?.services ?? []).length; index++) {
        const serviceObj = (currGroup?.services ?? [])?.[index];

        if (serviceObj?.serviceId === ele?.id) {
          (serviceObj?.groupedModes ?? []).forEach((groupMode) =>
            modesUsed.add(groupMode)
          );
        }

        // check if all modes exhausted..
        isThisServiceAlreadyUsedInCurrGroupWithAllModesExhausted =
          areSetAndArrayEqual(
            modesUsed,
            (ele?.serviceModeDetails ?? [])
              .filter(
                (eleme) => eleme?.isEnabled && eleme?.isAdvanceRuleApplicable
              )
              .map((ee) => ee?.modeName)
          );

        if (isThisServiceAlreadyUsedInCurrGroupWithAllModesExhausted) {
          break;
        }
      }

      return !isThisServiceAlreadyUsedInCurrGroupWithAllModesExhausted;
    });

    //First remove null IDed objects then, extract out only serviceIds from this services array to make array of ServiceIDs..
    return (servicesFiltered ?? []).filter((serv) => serv?.id).map((s) => s.id);
  };

  const getService = (array, serviceId) => {
    return (array ?? []).find(
      (element) => (element?.id ?? -1) === (serviceId ?? -2)
    );
  };

  const isThisModeOfThisServiceAlreadyUsedInThisGroup = (
    currGroup,
    currServiceObj,
    currServiceObjIdx,
    modeName
  ) => {
    let result = false;

    for (let index = 0; index < (currGroup?.services ?? []).length; index++) {
      const element = (currGroup?.services ?? [])[index];

      // isThisModeOfThisServiceAlreadyUsedInThisGroup on any other service than current
      if (
        index !== currServiceObjIdx &&
        element?.serviceId === currServiceObj?.serviceId
      ) {
        result = (element?.groupedModes ?? []).some(
          (modee) => modee === modeName
        );
      }

      if (result) {
        break;
      }
    }

    return result;
  };

  function removeAtIndexNonMutating(arr, index) {
    if (index < 0 || index >= arr.length) {
      return [...arr];
    }
    return [...arr.slice(0, index), ...arr.slice(index + 1)];
  }

  const getAdvSpRuleSection = () => {
    return (
      <div className="adv-sp-rule-service-modes-section-outermost-div">
        <div
          className="adv-sp-rule-define-adv-rule-header-div"
          onClick={(eve) => {
            // setExtraAssignServiceToPlanModesData((prev) => ({
            //   ...prev,
            //   [service.id]: {
            //     ...prev?.[service.id],
            //     headerExpanded: !(prev?.[service.id]?.headerExpanded ?? false),
            //   },
            // }));
          }}
        >
          <div style={{ fontWeight: 700 }}>
            Define advanced sponsorship rule here&nbsp;&nbsp;
            <FontIcon
              onClick={(event) => {
                setInfoPopupDialogObject((prev) => ({
                  heading: "What is 'Define advanced sponsorship rule here'?",
                  subHeading: (
                    <>
                      <br></br>
                      <p>
                        This section allows you to define complex rules that
                        must be met for a specific sponsorship to apply to an
                        employee. The rules are built using a combination of
                        services and the mode in which the service is availed.
                        <br />
                        <br />
                        <b>Rule Logic</b>
                        <ul>
                          <li>
                            <b>Combinations (1., 2., etc.):</b> The overall
                            sponsorship rule is applied according to the
                            services used from any combination, if the
                            conditions in 
                            <b>ANY SINGLE COMBINATION</b> are met.
                            <ul>
                              <li>
                                Example: Rule applies to that combination whose
                                services will be used on priority, it can be any
                                combination (as per added).
                              </li>
                            </ul>
                          </li>
                          <li>
                            <b>Rows (within a Combination):</b> All individual
                            services within a single combination will be
                            considered grouped defined by <b>‘+’</b> sign
                            <ul>
                              <li>
                                Example: For Combination 1, you can add multiple
                                rows and in a row you can choose a service you
                                added, then choose which mode you want to apply
                                a rule
                              </li>
                            </ul>
                          </li>
                        </ul>
                        <br></br>
                        <br></br>
                        <b>Rule Components</b>
                        <ul>
                          <li>
                            <b>Choose service:</b> Select the specific service
                            (e.g., 'Full body health checkup') that must be
                            included in the sponsorship page for the rule to
                            apply.
                          </li>
                          <li>
                            <b>Can be availed in:</b> Select one or more modes.
                            The condition for that specific row is met if the
                            chosen service is availed at ANY of the selected
                            modes (OR logic for modes).
                            <ul>
                              <li>
                                Example: Checking 'Home visit' OR 'Center visit'
                                means the row condition is satisfied if the
                                service occurs at either mode and can be availed
                                in either of the two.
                              </li>
                            </ul>
                          </li>
                          <li>
                            <b>+Add new row:</b> Adds a new service condition to
                            the current combination.
                          </li>
                          <li>
                            <b>+Add new combination:</b> Adds a new set of
                            conditions, separated by the 'or' conjunction, which
                            can independently trigger the sponsorship rule.
                          </li>
                        </ul>
                      </p>
                    </>
                  ),
                }));
                event.stopPropagation();
              }}
              style={{
                color: "#F97F0F",
                fontSize: "18px",
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              info
            </FontIcon>
          </div>
        </div>

        {(baseGroups ?? []).map((currGroup, currGroupIdx) => (
          <>
            {(currGroup?.services ?? []).map(
              (currServiceObj, currServiceObjIdx) => (
                <div>
                  <div className="adv-sp-rule-define-adv-rule-row">
                    <div
                      style={currServiceObjIdx === 0 ? {} : { color: "white" }}
                      className="adv-sp-rule-define-adv-rule-number"
                    >{`${currGroupIdx + 1}.`}</div>

                    <div style={{ width: "20px" }}></div>

                    <div className="adv-sp-rule-service-field-container">
                      <div className="mp-plan-label">
                        {`Choose service`}
                        <label className="account-module-label-red"> *</label>
                      </div>
                      <div style={{ height: "2px" }}></div>
                      <div>
                        <Autocomplete
                          style={{
                            width: "100%",
                            maxHeight: "200px",
                            overflowY: "scroll",
                            overflowX: "hidden",
                          }}
                          id="multiple-limit-service-provider-name"
                          options={transformServicesArrayForGroupRule(
                            formData?.servicesAdded ?? [],
                            currGroupIdx,
                            currServiceObjIdx
                          )}
                          disabled={
                            props?.data?.mode == "view" ||
                            groupRuleByIdResponse?.status === 2
                          }
                          getOptionLabel={(option) => {
                            let service = getService(
                              formData?.servicesAdded ?? [],
                              option
                            );
                            let res = `(${service?.id ?? ""}) ${
                              service?.name ?? ""
                            } - ${service?.serviceName ?? ""}`;

                            return res ?? "-";
                          }}
                          value={
                            baseGroups?.[currGroupIdx]?.services?.[
                              currServiceObjIdx
                            ]?.serviceId
                          }
                          onChange={(e, v) => {
                            // if (v) {
                            // setFormData((prev) => ({ ...prev, service: v }));
                            setBaseGroups((prev) => {
                              let newVal = [...prev];
                              if (
                                newVal[currGroupIdx]?.services?.[
                                  currServiceObjIdx
                                ]
                              ) {
                                newVal[currGroupIdx].services[
                                  currServiceObjIdx
                                ].serviceId = v;
                                newVal[currGroupIdx].services[
                                  currServiceObjIdx
                                ].groupedModes = null;
                              }

                              return newVal;
                            });
                            // }
                          }}
                          renderInput={(params) => (
                            <TextFieldMui
                              onChange={(e, v) => {
                                // handleFetchServiceProviderNameOpt(e.target.value);
                              }}
                              {...params}
                              placeholder="Type and select"
                              className="autocomplete-text-field-class"
                            />
                          )}
                        />
                      </div>

                      {Boolean(
                        (
                          getService(
                            formData?.servicesAdded ?? [],
                            currServiceObj?.serviceId
                          )?.serviceModeDetails ?? []
                        ).filter((mo) =>
                          Boolean(mo?.isEnabled && mo?.isAdvanceRuleApplicable)
                        ).length > 0
                      ) && (
                        <div>
                          <div style={{ height: "8px" }}></div>
                          <div className="mp-plan-label">{`Can be availed in ${
                            (
                              getService(
                                formData?.servicesAdded ?? [],
                                currServiceObj?.serviceId
                              )?.serviceModeDetails ?? []
                            ).filter((mo) =>
                              Boolean(
                                mo?.isEnabled && mo?.isAdvanceRuleApplicable
                              )
                            ).length > 1
                              ? `either`
                              : ``
                          }`}</div>
                          <div style={{ height: "4px" }}></div>

                          <div className="adv-sp-rule-modes-row-outer-div">
                            {(
                              getService(
                                formData?.servicesAdded ?? [],
                                currServiceObj?.serviceId
                              )?.serviceModeDetails ?? []
                            )
                              .filter((mo) =>
                                Boolean(
                                  mo?.isEnabled && mo?.isAdvanceRuleApplicable
                                )
                              )
                              .map((currMode, currModeIdx) => (
                                <div className="adv-sp-rule-service-field-modes-row">
                                  <div className="adv-sp-rule-service-field-modes-row-inner">
                                    <Checkbox
                                      style={{ marginRight: 0, padding: 0 }}
                                      checked={(
                                        currServiceObj?.groupedModes ?? []
                                      ).some(
                                        (m) =>
                                          m ===
                                          (currMode?.modeName ?? "RandomXYZ")
                                      )}
                                      color="secondary"
                                      disabled={
                                        props?.data?.mode == "view" ||
                                        groupRuleByIdResponse?.status === 2 ||
                                        isThisModeOfThisServiceAlreadyUsedInThisGroup(
                                          currGroup,
                                          currServiceObj,
                                          currServiceObjIdx,
                                          currMode?.modeName
                                        )
                                      }
                                      onChange={(e) => {
                                        // rule.planGenderRule.isApplicable = e.target.checked;
                                        // setAdvanceRule(rule);
                                        if (!currMode?.modeName) {
                                          return;
                                        }

                                        if (e.target.checked) {
                                          // check = true case
                                          setBaseGroups((prev) => {
                                            let newVal = [...prev];
                                            if (
                                              newVal[currGroupIdx]?.services?.[
                                                currServiceObjIdx
                                              ]
                                            ) {
                                              const prevGroupedModes = [
                                                ...(newVal[currGroupIdx]
                                                  .services[currServiceObjIdx]
                                                  .groupedModes ?? []),
                                              ];

                                              newVal[currGroupIdx].services[
                                                currServiceObjIdx
                                              ].groupedModes = [
                                                ...new Set([
                                                  ...prevGroupedModes,
                                                  currMode?.modeName,
                                                ]),
                                              ];
                                            }

                                            return newVal;
                                          });
                                        } else {
                                          // uncheck case
                                          setBaseGroups((prev) => {
                                            let newVal = [...prev];
                                            if (
                                              newVal[currGroupIdx]?.services?.[
                                                currServiceObjIdx
                                              ]
                                            ) {
                                              const prevGroupedModes = [
                                                ...(newVal[currGroupIdx]
                                                  .services[currServiceObjIdx]
                                                  .groupedModes ?? []),
                                              ];

                                              newVal[currGroupIdx].services[
                                                currServiceObjIdx
                                              ].groupedModes = [
                                                ...new Set(
                                                  [...prevGroupedModes].filter(
                                                    (v) =>
                                                      v !== currMode?.modeName
                                                  )
                                                ),
                                              ];
                                            }

                                            return newVal;
                                          });
                                        }
                                      }}
                                    />
                                    <div className="mp-plan-label">
                                      {`${currMode?.modeName ?? "-"}`}
                                    </div>
                                  </div>

                                  {Boolean(
                                    currModeIdx ===
                                      (
                                        getService(
                                          formData?.servicesAdded ?? [],
                                          currServiceObj?.serviceId
                                        )?.serviceModeDetails ?? []
                                      ).filter((mo) =>
                                        Boolean(
                                          mo?.isEnabled &&
                                            mo?.isAdvanceRuleApplicable
                                        )
                                      ).length -
                                        1
                                  ) ? (
                                    <></>
                                  ) : (
                                    <div className="adv-sp-rule-service-field-modes-or-text">{`or`}</div>
                                  )}
                                </div>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>

                    <div style={{ width: "20px" }}></div>

                    <IconButton
                      disabled={
                        props?.data?.mode == "view" ||
                        groupRuleByIdResponse?.status === 2 ||
                        ((baseGroups ?? []).length <= 1 &&
                          (baseGroups?.[0]?.services ?? []).length <= 1)
                      }
                      onClick={(event) => {
                        if (
                          (baseGroups ?? []).length <= 1 &&
                          (baseGroups?.[0]?.services ?? []).length <= 1
                        ) {
                          EventService.emit("showError", {
                            message: `Cannot delete the only row in the only group.`,
                          });
                          return;
                        }
                        setBaseGroups((prev) => {
                          let newVal = [...prev];
                          if (newVal[currGroupIdx]?.services) {
                            const prevServices = newVal[currGroupIdx].services;

                            newVal[currGroupIdx].services =
                              removeAtIndexNonMutating(
                                prevServices ?? [],
                                currServiceObjIdx
                              );
                          }

                          if (
                            (newVal?.[currGroupIdx]?.services ?? []).length < 1
                          ) {
                            newVal.splice(currGroupIdx, 1); // delete if no element is present anymore
                          }

                          return newVal;
                        });
                        event.stopPropagation();
                      }}
                      className="navigo-appoint-section-6-grid-edit-call"
                    >
                      <CloseIcon
                        style={{
                          color:
                            props?.data?.mode == "view" ||
                            groupRuleByIdResponse?.status === 2 ||
                            ((baseGroups ?? []).length <= 1 &&
                              (baseGroups?.[0]?.services ?? []).length <= 1)
                              ? "#ffffff"
                              : "#000000",
                          height: "16px",
                          width: "16px",
                          fontWeight: 700,
                        }}
                      />
                    </IconButton>
                  </div>

                  {Boolean(
                    currServiceObjIdx ===
                      (baseGroups?.[currGroupIdx]?.services ?? []).length - 1
                  ) ? (
                    <></>
                  ) : (
                    <div className="adv-sp-rule-group-separation-or-outer-div">
                      +
                    </div>
                  )}
                </div>
              )
            )}

            {!Boolean(groupRuleByIdResponse?.status === 2) && (
              <div
                className="adv-sp-rule-add-new-btn-enabled"
                onClick={() => {
                  // check if row addition is allowed
                  if (!areBaseGroupsValid(baseGroups ?? [])) {
                    return;
                  }

                  setBaseGroups((prev) => {
                    let newVal = [...prev];
                    if (newVal?.[currGroupIdx]) {
                      newVal[currGroupIdx].services = [
                        ...(prev?.[currGroupIdx]?.services ?? []),
                        EMPTY_BASE_GROUP_SERVICE_OBJ,
                      ];
                    }

                    return newVal;
                  });
                }}
              >
                +Add new row
              </div>
            )}

            {Boolean(currGroupIdx === (baseGroups ?? []).length - 1) ? (
              <></>
            ) : (
              <div className="adv-sp-rule-group-separation-or-outer-div">
                <div className="adv-sp-rule-group-separation-or-line"></div>
                or
                <div className="adv-sp-rule-group-separation-or-line"></div>
              </div>
            )}
          </>
        ))}
      </div>
    );
  };

  const getPopupDialog = () => {
    return (
      Boolean(popupDialogObject) && (
        <div className="modal-overlay">
          <div
            style={{ minHeight: "fit-content" }}
            className="modal error-modal"
          >
            <h4>{popupDialogObject?.heading ?? ""}</h4>
            <div className="error-modal-content">
              {popupDialogObject?.subHeading ?? ""}
            </div>

            <div style={{ height: "16px" }}></div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                raised
                className={
                  popupDialogObject?.okayButtonClassName ??
                  "mp-plan-button-publish-enabled"
                }
                onClick={() => {
                  if (popupDialogObject?.okayButtonCallback) {
                    popupDialogObject.okayButtonCallback();
                  }
                }}
              >
                {popupDialogObject?.okayButtonText ?? ""}
              </Button>
              <div style={{ height: "32px" }}></div>

              <Button
                raised
                className={"mp-plan-button-cancel"}
                onClick={() => {
                  if (popupDialogObject?.cancelButtonCallback) {
                    popupDialogObject.cancelButtonCallback();
                  }
                }}
              >
                {popupDialogObject?.cancelButtonText ?? ""}
              </Button>
            </div>
            <div style={{ height: "8px" }}></div>
          </div>
        </div>
      )
    );
  };

  const getInfoPopupDialog = () => {
    return (
      Boolean(infoPopupDialogObject) && (
        <div className="modal-overlay">
          <div
            style={{
              minHeight: "fit-content",
              maxWidth: "800px",
              textAlign: "left",
            }}
            className="modal error-modal"
          >
            <div
              style={{
                fontFamily: "Montserrat",
                fontSize: "24px",
                fontWeight: 500,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {infoPopupDialogObject?.heading ?? ""}
              <IconButton
                onClick={(event) => {
                  setInfoPopupDialogObject((prev) => null);
                  event.stopPropagation();
                }}
                className="navigo-appoint-section-6-grid-edit-call"
              >
                <CloseIcon
                  style={{
                    color: "#000000",
                    height: "24px",
                    width: "24px",
                    fontWeight: 700,
                  }}
                />
              </IconButton>
            </div>
            <div className="error-modal-content">
              {infoPopupDialogObject?.subHeading ?? ""}
            </div>
          </div>
        </div>
      )
    );
  };

  const getAssignedServicesToPlanByFilter = (
    id,
    pageNo,
    pageSizee,
    filters,
    updateIntoServicesAdded
  ) => {
    const onResponse = (res) => {
      if (updateIntoServicesAdded) {
        setFormData((prev) => ({
          ...prev,
          servicesAdded: res?.services ?? [],
        }));
      } else {
        setAssignedServicesArray(res?.services ?? []);
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };

    plansUtils.getAssignedServicesToPlanByFilter(
      {
        pageNum: pageNo ?? 0,
        pageSize: pageSizee ?? pageSize,
        planIds: [id],
        ...(filters ? filters : {}),
        includeGroupRuleDetails: true,
        // "serviceTypeIds":["67ac2bf47a2de919dc103605"]
      },
      onResponse,
      onError
    );
  };

  const finalAssignedServicesArray = (assignedServicesArray, servicesAdded) => {
    // Case 1
    // finalAssignedServicesArrayWithAlreadyAddedServicesRemoved
    // also remove the services where serviceGroupRuleId exist & serviceGroupRuleStatus is 1 or 2 i.e draft or published
    let finalAssignedServicesArrayWithAlreadyAddedServicesRemoved = (
      assignedServicesArray ?? []
    ).filter(
      (e) =>
        !(
          (servicesAdded ?? []).some(
            (ele) => (ele?.id ?? -1) === (e?.id ?? -2)
          ) ||
          (!(e?.serviceGroupRuleId === groupRuleByIdResponse?.id) &&
            (e?.serviceGroupRuleStatus === 1 ||
              e?.serviceGroupRuleStatus === 2))
        )
    );

    // Case 2
    // isThisServiceHasAnyModeWith_IsAdvanceRuleApplicable -> if yes then take this service otherwise do not take this service.
    return (
      finalAssignedServicesArrayWithAlreadyAddedServicesRemoved ?? []
    ).filter((elemen) =>
      (elemen?.serviceModeDetails ?? []).some((eleme) =>
        Boolean(
          Boolean(eleme?.isEnabled) && Boolean(eleme?.isAdvanceRuleApplicable)
        )
      )
    );
  };

  function moveToFrontById(arr, id) {
    if (!Array.isArray(arr) || arr.length === 0 || id == null) {
      return arr ?? []; // return [] if arr is null
    }

    const element = arr.find((e) => e?.id === id);
    if (!element) return arr;

    return [element, ...arr.filter((e) => e?.id !== id)];
  }

  return (
    <div className="mp-plan-page-padding mp-astp-first-div">
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="mp-plan-view">
            <div className="mp-plan-heading-with-back-button">
              <div
                className="mp-plan-back-btn"
                onClick={() => {
                  if (
                    groupRuleByIdResponse?.status === 2 ||
                    groupRuleByIdResponse?.status === 3
                  ) {
                    exitPage();
                    return;
                  }
                  setPopupDialogObject({
                    heading: "Are you sure you want to go back?",
                    subHeading: (
                      <p style={{ textAlign: "center", fontWeight: 400 }}>
                        Any unsaved changes will be lost
                      </p>
                    ),
                    okayButtonText: "Keep editing",

                    okayButtonCallback: () => {
                      setPopupDialogObject(null);
                    },
                    okayButtonClassName: "mp-plan-button-save-enabled",
                    cancelButtonText: "Go back",
                    cancelButtonCallback: () => {
                      setPopupDialogObject(null);
                      exitPage();
                    },
                  });
                }}
              >
                <FontIcon style={{ fontSize: "36px", marginTop: "2px" }}>
                  arrow_back
                </FontIcon>
              </div>
              <h1>{`Advanced sponsorship rule`}</h1>
            </div>
            <div className="mp-plan-buttons-container">
              <div className="mp-plan-buttons-right-alignment">
                {Boolean(
                  props?.data?.mode != "view" &&
                    groupRuleByIdResponse?.status !== 2
                ) && (
                  <Button
                    raised
                    disabled={
                      !(formData?.isContinueClicked ?? false) ||
                      props?.data?.mode == "view" ||
                      groupRuleByIdResponse?.status === 2 ||
                      (formData?.servicesAdded ?? []).length <= 0 ||
                      (baseGroups ?? []).length <= 0
                    }
                    className={
                      !(formData?.isContinueClicked ?? false)
                        ? "mp-plan-button-save-disabled"
                        : "mp-plan-button-save-enabled"
                    }
                    onClick={() => {
                      if (isFormValid(formData, baseGroups)) {
                        if (groupRuleByIdResponse?.id) {
                          if (groupRuleByIdResponse?.status !== 1) {
                            EventService.emit("showError", {
                              message: `Cannot publish advance rule which is not in draft state`,
                            });
                            return;
                          }

                          updateGroupRule(
                            prepareBodyForGroupRuleUpdation(
                              1,
                              groupRuleByIdResponse?.id
                            )
                          );
                        } else {
                          createGroupRule(prepareBodyForGroupRuleCreation());
                        }
                      }
                    }}
                  >
                    Save as draft
                  </Button>
                )}

                {Boolean(
                  props?.data?.mode != "view" &&
                    groupRuleByIdResponse?.status === 1
                ) && (
                  <Button
                    raised
                    disabled={
                      !(formData?.isContinueClicked ?? false) ||
                      props?.data?.mode == "view" ||
                      !(groupRuleByIdResponse?.status === 1)
                    }
                    className={
                      !(formData?.isContinueClicked ?? false)
                        ? "mp-plan-button-publish-disabled"
                        : "mp-plan-button-publish-enabled"
                    }
                    onClick={() => {
                      if (groupRuleByIdResponse?.status !== 1) {
                        EventService.emit("showError", {
                          message: `Cannot publish advance rule which is not in draft state`,
                        });
                        return;
                      }
                      if (isFormValid(formData, baseGroups)) {
                        setPopupDialogObject({
                          heading: "Are you sure you want to publish?",
                          subHeading: (
                            <p style={{ textAlign: "center", fontWeight: 400 }}>
                              Once published successfully, advanced sponsorship
                              rules will go live on plan and <b>can't</b> be
                              edited later.
                              <br />
                              <br />
                              You will only be able to unpublish the rule.
                            </p>
                          ),
                          okayButtonText: "Publish",

                          okayButtonCallback: () => {
                            updateGroupRule(
                              prepareBodyForGroupRuleUpdation(
                                2,
                                groupRuleByIdResponse?.id
                              )
                            );

                            setPopupDialogObject(null);
                          },
                          cancelButtonText: "Cancel",
                          cancelButtonCallback: () => {
                            setPopupDialogObject(null);
                          },
                        });
                      }
                    }}
                  >
                    Publish
                  </Button>
                )}

                {Boolean(groupRuleByIdResponse?.status === 2) && (
                  <Button
                    raised
                    disabled={
                      !(formData?.isContinueClicked ?? false) ||
                      !(groupRuleByIdResponse?.status === 2)
                    }
                    className={
                      !(formData?.isContinueClicked ?? false)
                        ? "mp-plan-button-publish-disabled"
                        : "mp-plan-button-publish-enabled"
                    }
                    onClick={() => {
                      // if (isFormValid(formData, baseGroups)) {
                      setPopupDialogObject({
                        heading: "Are you sure you want to unpublish?",
                        subHeading: (
                          <p style={{ textAlign: "center", fontWeight: 400 }}>
                            Once unpublished, you will <b>NOT</b> be able to
                            publish it again.
                          </p>
                        ),
                        okayButtonText: "Unpublish",
                        okayButtonCallback: () => {
                          unpublishGroupRule(groupRuleByIdResponse?.id);
                          setPopupDialogObject(null);
                        },
                        cancelButtonText: "Cancel",
                        cancelButtonCallback: () => {
                          setPopupDialogObject(null);
                        },
                      });

                      // }
                    }}
                  >
                    Unpublish
                  </Button>
                )}

                {/* <Button
                  raised
                  className="mp-plan-button-cancel"
                  onClick={() => {
                    exitPage();
                  }}
                >
                  {"Cancel"}
                </Button> */}
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <br />
      <br />
      <div className="mp-plan-grey-heading">Plan details</div>
      <br />
      <div className="mp-plan-create-service-container">
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">{`Plan ID`}</div>
              <div>
                <TextField
                  value={props?.data?.planId ?? ""}
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">{`Plan name`}</div>
              <div>
                <TextField
                  value={planData?.basicDetails?.name ?? ""}
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">{`Account name`}</div>
              <div>
                <TextField
                  value={accountDetails?.accountName ?? ""}
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div style={{ height: "24px" }}></div>

      {Boolean(groupRuleByIdResponse?.id) && (
        <>
          <Row>
            <Col xs={12} sm={3} md={3} lg={3}>
              <div className="mp-plan-create-service-field-container">
                <div className="mp-plan-label">{`Rule ID`}</div>
                <div>
                  <TextField
                    value={groupRuleByIdResponse?.id ?? "-"}
                    lineDirection="left"
                    disabled
                  />
                </div>
              </div>
            </Col>
          </Row>
          <div style={{ height: "24px" }}></div>
        </>
      )}

      <h3>Select service type</h3>

      <div className="mp-plan-create-service-container">
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">
                {`Service type`}
                <label className="account-module-label-red"> *</label>
              </div>
              <div>
                <SelectField
                  placeholder="Select"
                  className="mp-plan-select-field"
                  menuItems={
                    serviceTypes
                      ? serviceTypes?.map((e) => ({
                          label: e?.name,
                          value: e?.id,
                        }))
                      : []
                  }
                  disabled={formData?.isContinueClicked ?? false}
                  value={formData?.serviceTypeId ?? ""}
                  onChange={(e, idx) => {
                    setFormData((prev) => ({
                      ...prev,
                      service: null,
                      serviceTypeId: e,
                    }));
                    // updateFormDataField("service", "serviceTypeId", e);
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Button
            style={{
              marginLeft: "8px",
              marginTop: "18px",
              textTransform: "none",
            }}
            raised
            secondary
            disabled={
              (formData?.isContinueClicked ?? false) || !formData?.serviceTypeId
            }
            onClick={() => {
              setFormData((prev) => ({ ...prev, isContinueClicked: true }));
              getAssignedServicesToPlanByFilter(props?.data?.planId, 0, 0, {
                serviceTypeIds: [formData?.serviceTypeId],
              });
              getServiceTypeDataById(formData?.serviceTypeId);
            }}
          >
            Confirm
          </Button>
        </Row>
      </div>

      {Boolean(
        (formData?.isContinueClicked ?? false) && !(props?.data?.mode == "view")
      ) && (
        <>
          <div style={{ height: "24px" }}></div>

          <h3>Add new service</h3>

          <div className="mp-plan-create-service-container">
            <Row>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">
                    {`Select service`}
                    <label className="account-module-label-red"> *</label>
                  </div>
                  <div style={{ height: "2px" }}></div>
                  <div>
                    <Autocomplete
                      style={{
                        width: "100%",
                        maxHeight: "200px",
                        overflowY: "scroll",
                        overflowX: "hidden",
                      }}
                      id="multiple-limit-service-provider-name"
                      options={finalAssignedServicesArray(
                        assignedServicesArray ?? [],
                        formData?.servicesAdded ?? []
                      )}
                      getOptionLabel={(option) => {
                        if (!option?.id) {
                          return "";
                        }
                        let res = `(${option?.id ?? ""}) ${
                          option?.name ?? ""
                        } - ${option?.serviceName ?? ""}`;

                        return res ?? "-";
                      }}
                      value={formData?.service ?? {}}
                      onChange={(e, v) => {
                        // if (v) {
                        setFormData((prev) => ({ ...prev, service: v }));
                        // }
                      }}
                      renderInput={(params) => (
                        <TextFieldMui
                          onChange={(e, v) => {
                            // handleFetchServiceProviderNameOpt(e.target.value);
                          }}
                          {...params}
                          placeholder="Type and select"
                          className="autocomplete-text-field-class"
                        />
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Button
                style={{
                  marginLeft: "8px",
                  marginTop: "18px",
                  textTransform: "none",
                }}
                raised
                secondary
                disabled={!formData?.service?.id}
                onClick={() => {
                  if (
                    (formData?.servicesAdded ?? []).some(
                      (ele) => (ele?.id ?? -1) === (formData?.service?.id ?? -2)
                    )
                  ) {
                    EventService.emit("showError", {
                      message: `This service is already added`,
                    });
                    return;
                  }
                  if (isServiceValidForConfirm()) {
                    setFormData((prev) => ({
                      ...prev,

                      servicesAdded: [
                        ...(prev?.servicesAdded ?? []),
                        ...(prev?.service ? [prev?.service] : []),
                      ],
                      service: null,
                    }));
                  }
                }}
              >
                Add
              </Button>
            </Row>
          </div>
        </>
      )}
      <br />
      <div style={{ height: "48px" }}></div>
      {Boolean(
        (formData?.isContinueClicked ?? false) &&
          (formData?.servicesAdded ?? []).length > 0
      ) && getServicesAddedSection()}

      <div style={{ height: "48px" }}></div>

      {Boolean((formData?.servicesAdded ?? []).length > 0) && (
        <div className="adv-sp-rule-frame-outer-div">
          <div className="adv-sp-rule-frame-left">
            {(
              moveToFrontById(
                formData?.servicesAdded ?? [],
                formData?.serviceSelectedForFocus?.id // bringing this service at top
              ) ?? []
            ).map((service) => (
              <>
                {getServiceModesSection(
                  service,
                  reverseConvertServiceModesData(service?.serviceModeDetails)
                )}
                <div style={{ height: "24px" }}></div>
              </>
            ))}
          </div>

          <div className="adv-sp-rule-frame-right">
            {getAdvSpRuleSection()}

            {!Boolean(groupRuleByIdResponse?.status === 2) && (
              <div
                className="adv-sp-rule-add-new-combination-enabled"
                onClick={() => {
                  // check if combination addition is allowed
                  if (!areBaseGroupsValid(baseGroups ?? [])) {
                    return;
                  }

                  setBaseGroups((prev) => [...prev, EMPTY_BASE_GROUP]);
                }}
              >
                +Add new combination
              </div>
            )}
          </div>

          <div style={{ height: "48px" }}></div>
        </div>
      )}

      {getPopupDialog()}
      {getInfoPopupDialog()}
    </div>
  );
};

export default AdvancedSponsorshipRule;
